"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
var _BrixelStatus = _interopRequireDefault(require("./BrixelStatus"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelButtonBox = props => {
  const {
    backIcon = 'primary200',
    background = 'white',
    bgTransparent = false,
    className = '',
    colorIcon = 'primary700',
    hoverEffect = true,
    icon = null,
    label,
    labelClass = '',
    multilineInfo = [],
    onClick = null,
    paddingIconClass = 'p-small-10',
    roundIcon = false,
    status = null,
    subtitle = null,
    subtitleClass = '',
    verticalView = false
  } = props;
  const formatColor = col => `${col.charAt(0).toUpperCase()}${col.slice(1)}`;
  const classNameHover = hoverEffect ? 'showHover' : 'hideHover';
  const bgClass = bgTransparent ? '' : `bg${formatColor(background)}`;
  const diplayClass = verticalView ? 'verticalLayout' : 'horizontalLayout';
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: e => onClick ? onClick(e) : '',
    className: `brixel-button-box ${classNameHover} ${bgClass} ${className} brdRadius p-1 a-t ${onClick ? 'cur-poi' : 'cur-def'} jc-b ${diplayClass}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${verticalView ? 'dis-fl-col' : 'dis-f a-c'}`
  }, icon && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: icon,
    className: `${paddingIconClass} bg${formatColor(backIcon)} icn${formatColor(colorIcon)} brdRadius txt${formatColor(colorIcon)} as-b`,
    rounded: roundIcon
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "labelText"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `${labelClass} labelTitle`
  }, label), subtitle && (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-c"
  }, status && (/*#__PURE__*/_react.default.createElement(_BrixelStatus.default, {
    color: status,
    className: "mr-1",
    zIndex: false
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: `labelSubtitle body2 ${subtitleClass}`,
    dangerouslySetInnerHTML: {
      __html: subtitle
    }
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "rightAction ml-2"
  }, multilineInfo.map((item, i) => (/*#__PURE__*/_react.default.createElement("div", {
    key: `icn_${i.toString()}`
  }, item.icon && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: item.icon,
    className: `txt${formatColor(item.color)} icn${formatColor(item.color)}`
  })), item.label && (/*#__PURE__*/_react.default.createElement("span", {
    className: `txt${formatColor(item.color)} body2`
  }, item.label)))))));
};
var _default = exports.default = BrixelButtonBox;